import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/sections/Projects/Projects.tsx");
